import * as types from './types/loader.js';

/**
 * @param data
 * @returns {(function(*): void)|*}
 */
export function setLoader(data) {
    return (dispatch) => {
        dispatch({
            type: types.SET_LOADER,
            data
        });
    };
}